import cx from "classnames"
import styles from "./icon.module.css"

export function Icon({
  svg = "",
  outlined = false,
  className = "w-10 h-10 md:w-14 md:h-14"
}) {
  if (!svg) {
    return null
  }

  return (
    <div
      className={cx(
        `${styles.icon} ${className} flex items-center justify-center rounded-full fill-current p-1.5`,
        {
          "bg-summer-green-100 text-white": !outlined,
          "bg-white text-summer-green-100 border-2 border-solid border-summer-green-100":
            outlined
        }
      )}
      dangerouslySetInnerHTML={{ __html: svg }}></div>
  )
}
